const LOAD_DATA_MASTER_LANGUAGE_SKILLS       = 'LOAD_DATA_MASTER_LANGUAGE'
const LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS = 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS'
const LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED  = 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED'
const UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS     = 'UNMOUNT_DATA_MASTER_LANGUAGE_SKILL'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const languageSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default languageSkillsReducer

